<template>
   <div>
      <div class="py-3 pl-3">
         {{ $t("account-page-facility-payout.title") }}
      </div>
      <div class="row pl-3 my-3">
         <div class="col-lg-6 col-md-6 col-xl-3">
            <div class="form-group row">
               <label class="col-5 col-form-label"> {{ $t("account-page-facility-payout.payout_date_from")
               }}</label>
               <div class="col-7">
                  <input v-model="filter.date_from" class="form-control" type="date" />
               </div>
            </div>
         </div>
         <div class="col-lg-6 col-md-6 col-xl-3">
            <div class="form-group row">
               <label class="col-5 col-form-label"> {{ $t("account-page-facility-payout.payout_date_to") }}</label>
               <div class="col-7">
                  <input v-model="filter.date_to" class="form-control" type="date" />
               </div>
            </div>
         </div>
         <div class="col-lg-6 col-md-6 col-xl-3">
            <button :disabled="!filter.date_to || !filter.date_from" type="button"
               class="btn btn-outline-primary btn-block" @click="filterPayoutList">{{
                  $t("account-page-facility-payout.search") }}</button>
         </div>
         <div class="col-lg-6 col-md-6 col-xl-3 mt-sm-3 mt-lg-0 mt-3 mt-sm-0 mt-md-0">
            <button @click="clearDates" type="button"
               class="btn btn-primary btn-block border">{{ $t("account-page-facility-payout.clear") }}</button>
         </div>
      </div>
      <div class="row pl-3 my-3">
         <div class="col-lg-12 mb-4">{{ $t("account-page-visitor.timezone") }} ({{ facility.timezone ?
            facility.timezone.value : "Asia/Tokyo" }})</div>
         <div class="col-12">
            <div class="table-responsive table-bordered visitors-table">
               <table id="dataTable" cellspacing="0" class="table table-bordered visitors-table mb-0" width="100%">
                  <thead>
                     <tr>
                        <th>{{ $t("account-page-facility-payout.payout_date") }}</th>
                        <th>{{ $t("account-page-facility-payout.amount") }} JPY</th>
                        <th>{{ $t("account-page-facility-payout.fee") }} JPY</th>
                        <th>{{ $t("account-page-facility-payout.processing_fee") }} JPY</th>
                        <th>{{ $t("account-page-facility-payout.vat") }} JPY</th>
                        <th>{{ $t("account-page-facility-payout.net") }} JPY</th>

                        <th class="text-center">{{ $t("account-page-facility-payout.operation") }}</th>
                     </tr>
                  </thead>

                  <tbody>
                     <tr v-for="(value, key) in listOfPayoutData.data" :key="key">
                        <td>{{ formatDateFacilityTimezoned(value.payout_date) }}</td>
                        <td>{{ formatAmount(value.amount) }}</td>
                        <td>{{ formatAmount(value.fee) }}</td>
                        <td>{{ formatAmount(value.processing_fee) }}</td>
                        <td>{{ formatAmount(value.vat) }}</td>
                        <td>{{ formatAmount(value.net) }}</td>

                        <td class="text-center">
                           <a class="btn btn-primary btn-sm cursor-pointer btn-block" href="javascript:void(0)"
                              role="button" @click="$refs.payoutListDetails.view(value)">{{
                                 $t("account-page-facility-payout.detail") }}</a>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>
            <div class="col-sm-8">
               <pagination
                  v-model="listOfPayoutData.current_page"
                  :per-page="listOfPayoutData.per_page"
                  :records="listOfPayoutData.total"
                  @paginate="paginate"
               ></pagination>
            </div>
         </div>
      </div>

      <PayoutListDetails ref="payoutListDetails" />
   </div>
</template>

<script>

import PayoutListDetails from "./payoutListDetails.vue";
import formatters from '@/mixins/formatters.js';

import {
  main_form_methods,
} from "@/modules/checkin-facility/utils/mockup.js";

const  { formatDateFacilityTimezoned } = main_form_methods;

export default {
   name: "ArbitragePayoutList",
   components: { PayoutListDetails },
   data() {
      return {
         listOfPayoutData: {
            data: [],
            current_page: 1,
            per_page: 10,
            total: 10
         },
         facility: window._app_facility,

         config: {},
         custom_filter: {},
         filter: {
            date_from: '',
            date_to: '',
            timezone: '',
            status: 'confirmed'
         },
         sessionFilterApplied: false,
      }
   },
   
   async mounted() {
      await this.init_filter();
      this.filter.timezone = this.facility.timezone ? this.facility.timezone.value : "Asia/Tokyo";
      await this.list(this.filter);
   },
   
   methods: {
      formatDateFacilityTimezoned,
      
      async init_filter() {
         this.filter.facility_id = this.facility.id;
         this.filter.date_from = '';
         this.filter.date_to = '';
      },

      async list(query) {
         this.listOfPayoutData = await this.$lionheart.get(`/v2/payout-list/${window._app_facility.id}`, { params: query }).then((success) => success.data.data);
      },
      
      async filterPayoutList() {
         this.sessionFilterApplied = true;
         await this.store_filter();
         await this.list(this.filter);
      },
      
      async clearDates() {
         this.filter.date_from = '';
         this.filter.date_to = '';
         this.sessionFilterApplied = true;
         await this.store_filter();
         await this.list(this.filter);
      },
      
      async store_filter() {
         this.$storage.set(`visitor_payments_payout_filter_${this.facility.id}`, {
            filter: this.filter,
            config: this.config,
            custom_filter: this.custom_filter,
            hasInteracted: true,
         });
      },
      
      async paginate(page) {
         var filter = {
            page: page,
            per_page: this.listOfPayoutData.per_page
         };
         await this.list(filter);
      },
   },
   mixins: [formatters],
}

</script>